import {
    Paper, TableBody, TableCell, styled, tableCellClasses,
    TableRow, IconButton, Typography
} from "@mui/material";
import UseTable from "../common/UseTable";
import { useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import { useNavigate } from "react-router-dom";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.body}`]: {
        whiteSpace: "nowrap",
    },
}));

const headCells = [
    { id: "clientId", label: "ID", width: 90 },
    { id: "client", label: "Name", width: 90 },
    {
        id: "total",
        label: "Received",
        width: 150,
        editable: true,
    },
    {
        id: "pending",
        label: "Pending",
        width: 150,
        editable: true,
    },
    {
        id: "fixed",
        label: "Fixed",
        width: 150,
        editable: true,
    },
    {
        id: "devops",
        label: "Forwarded to DevOps",
        width: 150,
        editable: true,
    },
    {
        id: "",
        label: "Action",
        sortable: false,
    },
];

const ClientIssues = (props) => {
    const { clientIssueRpt } = props;
    const [filterFn, setFilterFn] = useState({ fn: (items) => { return items; } });

    const {
        TblContainer,
        TblHeader,
        TblPagination,
        tblDataAfterPaginationAndSorting,
    } = UseTable(clientIssueRpt, headCells, filterFn);

    const navigate=useNavigate();


    return <>
        <Typography variant="h5" sx={{ mb: 2 }}>Customer Issues</Typography>
        <Paper sx={{ overflow: "auto" }}>
            <TblContainer>
                <TblHeader />
                <TableBody sx={{ background: "white" }}>
                    {tblDataAfterPaginationAndSorting().map((item) => (
                        <TableRow>
                            <TableCell>{item.clientId}</TableCell>
                            <TableCell>{item.clientName}</TableCell>
                            <StyledTableCell>
                                {item.totalIssues}
                            </StyledTableCell>
                            <StyledTableCell>{item.pendingIssues}</StyledTableCell>
                            <StyledTableCell>{item.fixedIssues}</StyledTableCell>
                            <StyledTableCell>{item.devOpsForwardedIssues}</StyledTableCell>
                            <TableCell>
                                <IconButton
                                    color="primary"
                                    component="span"
                                    onClick={() => navigate("/issues")}
                                >
                                    <RemoveRedEyeIcon />
                                </IconButton>
                            </TableCell>

                        </TableRow>
                    ))}
                </TableBody>
            </TblContainer>
        </Paper>
    </>
}

export default ClientIssues;